import { Dialog } from '@mui/material'
import { useState } from 'react'
import { match, P } from 'ts-pattern'
import { WaitingListAttendee } from 'domain/models/WaitingLists/WaitingListsRace'
import { LiveEventRace } from 'services/api/database/EventService'
import RegistrationForm from './RegistrationForm'
import { RegistrationSuccess } from './RegistrationSuccess'

interface WaitingListModaleProps {
  open: boolean
  onClose: () => void
  race: LiveEventRace
}

const WaitingListModale = ({ open, onClose, race }: WaitingListModaleProps) => {
  const [attendee, setAttendee] = useState<WaitingListAttendee | null>(null)

  const handleClose = () => {
    onClose()
    setAttendee(null)
  }

  return (
    <Dialog
      fullWidth
      PaperProps={{
        sx: {
          width: '416px',
          height: 'auto',
          '@media (max-width: 768px)': {
            margin: '16px'
          }
        }
      }}
      open={open}
      onClose={handleClose}
    >
      {match(attendee)
        .with(P.nullish, () => (
          <RegistrationForm
            open={open}
            onClose={handleClose}
            race={race}
            confirmRegistration={setAttendee}
          />
        ))
        .with(P.not(P.nullish), (registeredAttendee) => (
          <RegistrationSuccess
            raceName={race.name}
            waitingListAttendee={registeredAttendee}
            onClose={handleClose}
          />
        ))
        .exhaustive()}
    </Dialog>
  )
}

export default WaitingListModale
